export { default as WLPopover } from "./Popover.vue";
export { type PopoverProps, PopoverTrigger } from "./types";
